<template>
	<v-app dark>
		<nuxt />
	</v-app>
</template>

<script>
import { mapMutations } from "vuex";

export default {
	middleware: "auth",
};
</script>
